const Filter = require('../../../shared/ctxFiltersPanel/ctxFilterModel');
const Event = require('../../model/Event');
const Authority = require('../../model/Authority');
const TableState = require('../../model/TableState');
const { permissions } = require('../../constants/permissions');
const EVENTS_SEARCH_KEY = 'category';

class EventsPersistenceService {
    constructor($rootScope, $filter, $q, crudService, utilsService, sharedPersistenceService, storageService, iamPersistenceService) {
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this._$q = $q;
        this._utilsService = utilsService;
        this.crudService = crudService;
        this.utilsService = utilsService;
        this.storageService = storageService;
        this.iamPersistenceService = iamPersistenceService;
        this.sharedPersistenceService = sharedPersistenceService;
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
        this.datetimeLocaleFormat = this.utilsService.getDateTimeLocaleFormat(true);


        this.initFilter();

        this.$rootScope.$on("logout", () => {
            this.eventsTableState = undefined;
            this.clearFilter();
            this.storageService.clearCustomPageSize('events');
        });
        this.$rootScope.$on("force-logout", () => {
            this.eventsTableState = undefined;
            this.clearFilter();
            this.storageService.clearCustomPageSize('events');
        });
    }

    initFilter() {
        let isBackupAdmin = this._utilsService.isBackUpAdmin();
        this.filters = [];
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('vm.filters.resourceGroups'), Event.getResourceGroupsKey(), [], 'resourceGroups', true));
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('event.filters.category'), Event.getCategoryKey(), [], 'category', true));
        this.filters.push(Filter.getSelectFilter(this.$filter('translate')('event.filters.authority'), Event.getAuthorityKey(), [], 'authority', true));
        this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('event.filters.severity'), Event.getSeverityKey(), Event.getSeverityOptions(), 'severity'));
        let timeFilter = Filter.getTimeFilter(this.$filter('translate')('event.filters.timeRange'), Event.getTimeRangeKey(), Event.getTimeOptions(), 'timeRange');
        timeFilter.datetimeLocaleFormat = this.datetimeLocaleFormat;
        this.filters.push(timeFilter);

        this.updateFilters(isBackupAdmin);
    }

    initDropdownFilters() {
        let resourceGroupsFilter;

        this.getAllResourceGroups().then(resourceGroups => {
            resourceGroupsFilter = this.filters.filter(item => item.filterKey === Event.getResourceGroupsKey())[0];
            if (!resourceGroupsFilter) {
                this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('vm.filters.resourceGroups'), Event.getResourceGroupsKey(), [], 'resourceGroups', true));
                resourceGroupsFilter = this.filters.filter(item => item.filterKey === Event.getResourceGroupsKey())[0];
            }
            resourceGroupsFilter.options = resourceGroupsFilter.originalList = resourceGroups.map(
                (item, i) => {
                    return {
                        id: i,
                        label: item.label,
                        value: item.value
                    };
                });
        });

    }

    updateFilters(isBackupAdmin) {
        let authorityFilter, eventFilter;
        if (isBackupAdmin) {
            this.sharedPersistenceService.getAllVmAdminAuthorities().then(authorities => {
                authorityFilter = this.filters.filter(item => item.filterKey === Event.getAuthorityKey())[0];
                if (!authorityFilter) {
                    this.filters.splice(1, 0, Filter.getSelectFilter(this.$filter('translate')('event.filters.authority'), Event.getAuthorityKey(), [], 'authority'));
                    authorityFilter = this.filters.filter(item => item.filterKey === Event.getAuthorityKey())[0];
                }
                authorityFilter.options = authorityFilter.originalList = this.updateFilterOptions(authorities, authorityFilter, 'authority');

            });
        } else {
            this.filters = this.filters.filter(elem => elem.filterKey !== Event.getAuthorityKey());
        }
        this.getAllEventsCategories().then(events => {
            eventFilter = this.filters.filter(item => item.filterKey === Event.getCategoryKey())[0];
            eventFilter.options = eventFilter.originalList = events.map((event, i) => {
                return { id: i, label: this.utilsService.enumToNiceString(event), value: event, selected: false };
            });
        });
    }

    updateFilterOptions(items, filterItem, key) {
        let param = !key ? 'name' : key,
            selectedOptions = filterItem.selectedOptions ? filterItem.selectedOptions.map(item => item.value) : [];
        return items.map((item, i) => {
            return { id: i, label: item.label, value: item.value, group: item.group, selected: selectedOptions.indexOf(item[param]) > -1 };
        });
    }

    clearFilter() {
        if (this.eventsTableState) this.eventsTableState.page = 1;
        this.filters.forEach((filter) => {
            filter.clear();
        });
    }

    getAllResourceGroups() {
        return this.crudService.get(this.REST_ENDPOINTS.RESOURCE_GROUP_REST + '/dropDown', null, null, null, null, null, null, false).then(res => {
            return res.data.entities;
        });
    }

    getEmailNotificationDetails(uuid) {
        return this.crudService.get('eventEmails/' + uuid).then(res => {
            return res.data.entities[0];
        });
    }

    getWebHookNotificationDetails(uuid) {
        return this.crudService.get('eventWebHooks/' + uuid).then(res => {
            return res.data.entities[0];
        });
    }

    getWebHookJsonFormat(uuid) {
        if (uuid) {
            return this.crudService.get('eventWebHooks/template' + uuid).then(res => {
                return res.data.entities[0];
            });
        } else {
            return this.crudService.get('eventWebHooks/template').then(res => {
                return res.data.entities[0];
            });
        }
    }

    getAllEventsCategories() {
        return this.crudService.get(this.REST_ENDPOINTS.EVENTS_CATEGORIES_REST, null, null, null, null, true, false, true).then(res => {
            return res.data.entities;
        });
    }

    get(firstPage, filters, type, isExport) {
        if (!this.iamPersistenceService.hasPermissions(permissions.EVENT_LISTING)) {
            return this._$q((resolve) => { resolve([]); });
        }

        if (filters && typeof filters[4].setFilterByOptions === 'function') {
            filters[4].setFilterByOptions(filters[4]);
        }
        if (firstPage && this.eventsTableState) {
            this.eventsTableState.page = 1;
        }
        if (!this.eventsTableState) {
            this.eventsTableState = new TableState();
            this.eventsTableState.orderBy = '-created';
            // check if custom pageSize is set
            let tempPageSize = this.storageService.getCustomPageSize('events');
            if (tempPageSize) {
                this.eventsTableState.pageSize = tempPageSize;
            }
        }

        return this.crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.EVENTS_REST, this.eventsTableState, filters, null, Event.getTitleKey(), null, isExport).then(res => {
            let searchBy = undefined;
            if (angular.isDefined(this.eventsTableState.searchBy)) {
                searchBy = this.eventsTableState.searchBy;
            }
            this.eventsTableState = res.data.tableState;
            this.eventsTableState.searchBy = searchBy;

            // set pageSize value
            if (this.eventsTableState && this.eventsTableState.pageSize) this.storageService.setCustomPageSize('events', this.eventsTableState.pageSize);
            return res.data.entities;
        });
    }

    getAllEvents(firstPage, filters, searchBy, isExport) {
        let tableState = new TableState();
        tableState.pageSize = 1000000;
        if (searchBy) {
            tableState.searchBy = this.eventsTableState.searchBy;
        }
        return this.crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.EVENTS_REST, tableState, filters, null, null, null, isExport).then(res => {
            return res.data.entities;
        });
    }

    getDetails(uuid) {
        if (!this.iamPersistenceService.hasPermissions(permissions.EVENT_DETAILS)) {
            return this._$q((resolve) => { resolve([]); });
        }

        return this.crudService.get(this.REST_ENDPOINTS.EVENTS_REST + `/${uuid}`);
    }

    getRelatedTask(taskId) {
        return this.crudService.get(this.REST_ENDPOINTS.TASKS_REST + `/${taskId}`);
    }

}

EventsPersistenceService.$inject = ['$rootScope', '$filter', '$q', 'crudService', 'utilsService', 'sharedPersistenceService', 'storageService', 'iamPersistenceService'];

module.exports = EventsPersistenceService;



// WEBPACK FOOTER //
// ./src/azurebackup/views/events/events.persistence.service.js